import React from "react";
import "./RewardsFeatures.css";
import { navigate } from "@reach/router";

export default function RewardsFeatures() {
  return (
    <div id="scrollspySteps" className="rewards-features mb-5">
      <h2 className="features__title">
        Tu Constancia Tiene Premio: Descubre TBM Rewards
      </h2>
      <p className="features__desc mb-5">
        Mantente inspirada y comprometida con tus entrenamientos.
      </p>

      <div className="row card-container container align-items-center">
        <div className="card mb-3 mb-md-0">
          <h3 className="feat-title text-capitalize">PROGRESO VISIBLE</h3>
          <img className="feat-image" src="/img/feat-1.png" alt="jumping" />
          <p className="feat-desc text-white">
            Mide tu evolución y mantente inspirada y comprometida con tus
            entrenamientos.
          </p>
        </div>

        <div className="card mb-3 mb-md-0">
          <h3 className="feat-title text-capitalize">RECOMPENSAS</h3>
          <img className="feat-image" src="/img/feat-2.png" alt="tbm members" />
          <p className="feat-desc text-white">
            Avanza y accede a premios cada vez más increíbles. Disfruta de
            descuentos, regalos y experiencias de marcas líderes en bienestar
            (activewear, proteínas, skincare y más).
          </p>
        </div>

        <div className="card mb-3 mb-md-0">
          <h3 className="feat-title text-capitalize">MOTIVACIÓN CONTINUA</h3>
          <img className="feat-image" src="/img/feat-3.png" alt="pilates tbm" />
          <p className="feat-desc text-white">
            Siente el apoyo y celebra tus logros junto a otras alumnas de la
            Comunidad TBM.
          </p>
        </div>
      </div>

      <div className="row justify-content-center mt-5">
        <button onClick={() => navigate("/paquetes")} className="feat-btn btn ">
          <span className="rewards-text-gradient">
            COMIENZA YA
            <i className="fas fa-arrow-right ms-2" />
          </span>
        </button>
      </div>
    </div>
  );
}
